import { IProjectTypeScreenBehavior } from '../../interfaces/iproject-type-screen-behavior';
import { ProjectType } from '../project-type';

export class ProjectTypeScreenBehaviorBase {
  ProjectTypeScreenBehaviorId: number;
  ProjectTypeId: number | null;
  ComponentSelector: string;
  AppFunctionDescription: string;
  FieldName: string;
  Readonly: boolean;
  Visible: boolean;
  Required: boolean;
  InputHint: string | null;
  DefaultValue: string | null;
  DefaultValueSource: string | null;
  AvailableValuesLIst: string | null;
  AvailableValuesSource: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  ProjectType?: ProjectType;

  constructor(item?: IProjectTypeScreenBehavior) {
    if (item) {
      this.ProjectTypeScreenBehaviorId = item.ProjectTypeScreenBehaviorId;
      this.ProjectTypeId = item.ProjectTypeId;
      this.ComponentSelector = item.ComponentSelector;
      this.AppFunctionDescription = item.AppFunctionDescription;
      this.FieldName = item.FieldName;
      this.Readonly = item.Readonly;
      this.Visible = item.Visible;
      this.Required = item.Required;
      this.InputHint = item.InputHint;
      this.DefaultValue = item.DefaultValue;
      this.DefaultValueSource = item.DefaultValueSource;
      this.AvailableValuesLIst = item.AvailableValuesLIst;
      this.AvailableValuesSource = item.AvailableValuesSource;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectType = new ProjectType(item.ProjectType);
    }
  }
}